module.exports = "/images/modal-leave.svg?67cad4f139ffd75bbf3b84eee28eac5f";